import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterRangeBoxCurrencyHandler from "./IDataFilterRangeBoxCurrencyHandler";
import IDataFilterRangeCurrencyValue from "./IDataFilterRangeCurrencyValue";

export default class DataFilterRangeBoxCurrencyHandler
  implements IDataFilterRangeBoxCurrencyHandler
{
  setDescriptorValuesFromUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const storeCurrencyMin = urlParams.get(`${descriptor.name}From`);
    const storeCurrencyMax = urlParams.get(`${descriptor.name}To`);

    let rangeFilterValues: number[] = [];

    if (storeCurrencyMin) {
      rangeFilterValues[0] = Number.parseFloat(storeCurrencyMin);
    }
    if (storeCurrencyMax) {
      rangeFilterValues[1] = Number.parseFloat(storeCurrencyMax);
    }

    (descriptor.value as IDataFilterRangeCurrencyValue).value =
      rangeFilterValues;
  }

  setDescriptorValuesToUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const rangeCurrencyValue =
      descriptor.value as IDataFilterRangeCurrencyValue;

    this.setRangeValueToParams(
      descriptor,
      urlParams,
      rangeCurrencyValue.value[0],
      "From"
    );
    this.setRangeValueToParams(
      descriptor,
      urlParams,
      rangeCurrencyValue.value[1],
      "To"
    );
  }

  private setRangeValueToParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams,
    value: number | undefined,
    type: "From" | "To"
  ) {
    if (value !== undefined) {
      urlParams.set(`${descriptor.name}${type}`, value.toString());
    } else {
      urlParams.delete(`${descriptor.name}${type}`);
    }
  }
}
